import { ICategoria } from "shared/interfaces/ICategoria";
import { IProduto } from "shared/interfaces/IProduto";
import { api } from "../api";

/* ================================
   VITRINE DA LOJA (GET /storefront/:storeId/...)
   Erros não são engolidos aqui: a tela decide o que mostrar.
================================ */

export async function buscarCategoriasDaLoja(
  storeId: string,
): Promise<ICategoria[]> {
  const response = await api.get(`/storefront/${storeId}/categories`);

  const categorias = Array.isArray(response.data) ? response.data : [];

  return categorias.map((categoria: any) => ({
    id: categoria.id,
    nome: categoria.name,
    slug: categoria.slug,
  }));
}

interface ListarProdutosDaLojaParams {
  storeId: string;
  categoryId?: string;
  page?: number;
  limit?: number;
  sort?: "NEWEST" | "PRICE_ASC" | "PRICE_DESC" | "RELEVANCE";
}

export interface ListarProdutosDaLojaResponse {
  produtos: IProduto[];
  total: number;
  page: number;
  lastPage: number;
}

export async function listarProdutosDaLoja({
  storeId,
  ...params
}: ListarProdutosDaLojaParams): Promise<ListarProdutosDaLojaResponse> {
  // Mesmo formato de resposta do GET /v2/products.
  const response = await api.get(`/storefront/${storeId}/products`, {
    params,
  });

  const produtos = response.data.data ?? [];
  const meta = response.data.meta ?? {};

  const produtosFormatados = produtos.map((produto: any) => ({
    ...produto,
    lojaId: produto.storeId,
    descricao: produto.description,
    marca: produto.brand,
    estoque: produto.stock,
    categoriaId: produto.category?.id ?? produto.categoryId ?? "",
    categoriaNome: produto.category?.name ?? produto.categoryName ?? "",
    isActive: produto.isActive,
  }));

  return {
    produtos: produtosFormatados,
    total: Number(meta.total ?? produtosFormatados.length),
    page: Number(meta.page ?? params.page ?? 1),
    lastPage: Number(meta.lastPage ?? 1),
  };
}
